import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";
import fonts from "./fonts/fonts.css";

export default createGlobalStyle`
  ${reset}
  ${fonts}

  *{
    box-sizing: border-box;
  }
  *:focus {
    outline: none;
  }

  .more-link,
  .link-more{
    display: none !important;
  }

  em{
    font-style: italic;
  }

  .full{
    margin-left: -1rem;
    margin-right: -1rem;
  }

  a{
    text-decoration: none;
    color: inherit;
  }

  body{
    margin: 0!important;
    padding: 0;
  }

`;
